

export default {
    vi: {
        homepage: 'Trang chủ',
        report: 'Báo cáo',
        customer: 'Khách hàng',
        employee: 'Nhân viên',
        setting: 'Cài đặt',
        import: 'Nhập khẩu',
        collapse: 'Thu gọn'
    },
    en: {
        homepage: 'Home page',
        report: 'Report',
        customer: 'Customer',
        employee: 'Employee',
        setting: 'Setting',
        import: 'Import',
        collapse: 'Collapse'
    }
};

